export default {
    url: '/report/:guid',
    template: `
        <survey-public-report
            survey-group="vm.surveyGroup"
            company="vm.company"
            sites="vm.sites"
            classifiers="vm.classifiers"
            comparison-groups="vm.comparisonGroups"
        />
    `,
    resolve: {
        surveyGroup (SurveyGroupResource, $stateParams) {
            return SurveyGroupResource.publicView({ guid: $stateParams.guid, expand: 'activeI18n' }).$promise;
        },
        company (CompanyResource, surveyGroup) {
            return CompanyResource.publicView({ id: surveyGroup.companyId, expand: 'companySurveyI18ns' }).$promise;
        },
        sites (SiteResource) {
            return SiteResource.query({ pageSize: 0, planningSites: true }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ expand: 'activeI18n' }).$promise;
        },
        comparisonGroups ($stateParams, SurveyGroupResource) {
            return SurveyGroupResource.query({ comparisonGuid: $stateParams.guid, expand: 'activeI18n' }).$promise;
        }
    },
    controller ($rootScope, surveyGroup, company, sites, classifiers, comparisonGroups) {
        $rootScope.surveyGroup = surveyGroup;
        this.surveyGroup = surveyGroup;
        this.company = company;
        this.sites = sites;
        this.classifiers = classifiers;
        this.comparisonGroups = comparisonGroups;
        $rootScope.$emit('survey.loaded');
    }
};



// WEBPACK FOOTER //
// ./src/app/states/survey/report/index.js